// src/data/audiences.ts

import type { AudienceSegment } from "@/types";

export const AUDIENCES: AudienceSegment[] = [
  {
    id:            "seg-001",
    name:          "Power Tool In-Market — High Intent",
    estimatedSize: 840_000,
    filters:       ["Intent: Power Tools (score 70+)", "Recency: Last 7 days", "Geography: National"],
    refreshSchedule: "daily",
    channels:      ["display", "oo"],
    createdAt:     "2026-01-14T10:00:00Z",
    updatedAt:     "2026-03-17T06:00:00Z",
    status:        "active",
  },
  {
    id:            "seg-002",
    name:          "Grocery Loyalists — High Frequency",
    estimatedSize: 2_140_000,
    filters:       ["Loyalty: FreshMart Gold/Platinum tier", "Purchase freq: 2+ visits/week", "Lapse risk: Low"],
    refreshSchedule: "daily",
    channels:      ["oo", "display", "ctv"],
    createdAt:     "2026-01-20T10:00:00Z",
    updatedAt:     "2026-03-17T06:00:00Z",
    status:        "active",
  },
  {
    id:            "seg-003",
    name:          "Athletic Wear Enthusiasts",
    estimatedSize: 1_280_000,
    filters:       ["Intent: Athletic Wear (score 65+)", "Intent: Running & Fitness (score 60+)", "Age: 18-44"],
    refreshSchedule: "daily",
    channels:      ["ctv", "video", "display"],
    createdAt:     "2026-01-28T10:00:00Z",
    updatedAt:     "2026-03-17T06:00:00Z",
    status:        "active",
  },
  {
    id:            "seg-004",
    name:          "Consumer Electronics In-Market",
    estimatedSize: 3_840_000,
    filters:       ["Intent: Consumer Electronics (score 65+)", "Intent: Smartphones (score 60+)", "HHI: $75K+"],
    refreshSchedule: "daily",
    channels:      ["ctv", "display", "oo"],
    createdAt:     "2025-12-10T10:00:00Z",
    updatedAt:     "2026-03-17T06:00:00Z",
    status:        "active",
  },
  {
    id:            "seg-005",
    name:          "Health & Wellness Shoppers",
    estimatedSize: 4_120_000,
    filters:       ["Intent: Health & Wellness (score 60+)", "Intent: Vitamins & Supplements (score 55+)", "Geography: National"],
    refreshSchedule: "daily",
    channels:      ["display", "oo"],
    createdAt:     "2025-12-15T10:00:00Z",
    updatedAt:     "2026-03-17T06:00:00Z",
    status:        "active",
  },
  {
    id:            "seg-006",
    name:          "Lapsed Hardware Members — Win-Back",
    estimatedSize: 184_000,
    filters:       ["Loyalty: Midwest Hardware", "Last purchase: 90+ days ago", "Lapse risk score: 70+", "Intent: Home Improvement (any)"],
    refreshSchedule: "weekly",
    channels:      ["display", "oo"],
    createdAt:     "2026-02-01T10:00:00Z",
    updatedAt:     "2026-03-10T06:00:00Z",
    status:        "active",
  },
  {
    id:            "seg-007",
    name:          "New Parent Targeting",
    estimatedSize: 1_240_000,
    filters:       ["Intent: Baby & Infant Products (score 70+)", "Intent: Parenting (score 60+)", "Age: 24-38"],
    refreshSchedule: "daily",
    channels:      ["display", "video", "ctv"],
    createdAt:     "2026-01-25T10:00:00Z",
    updatedAt:     "2026-03-17T06:00:00Z",
    status:        "active",
  },
  {
    id:            "seg-008",
    name:          "Home Improvement Conquest Prospects",
    estimatedSize: 920_000,
    filters:       ["Intent: Home Improvement (score 75+)", "NOT: Midwest Hardware loyalty member", "Geography: Midwest Hardware DMAs"],
    refreshSchedule: "weekly",
    channels:      ["display", "oo"],
    createdAt:     "2026-02-10T10:00:00Z",
    updatedAt:     "2026-03-10T06:00:00Z",
    status:        "active",
  },
  {
    id:            "seg-009",
    name:          "Samsung Upgrade — iPhone Switchers",
    estimatedSize: 640_000,
    filters:       ["Intent: Smartphones (score 75+)", "Intent: Android Devices (score 65+)", "Device: iOS (current)"],
    refreshSchedule: "daily",
    channels:      ["ctv", "display"],
    createdAt:     "2026-01-05T10:00:00Z",
    updatedAt:     "2026-03-17T06:00:00Z",
    status:        "active",
  },
  {
    id:            "seg-010",
    name:          "Sustainable Fashion Early Adopters",
    estimatedSize: 210_000,
    filters:       ["Intent: Sustainable Fashion (score 65+)", "Loyalty: StyleNow Apparel", "Age: 22-40"],
    refreshSchedule: "weekly",
    channels:      ["display", "video"],
    createdAt:     "2026-02-18T10:00:00Z",
    updatedAt:     "2026-03-10T06:00:00Z",
    status:        "draft",
  },
  {
    id:            "seg-011",
    name:          "Grocery Delivery Switchers",
    estimatedSize: 780_000,
    filters:       ["Intent: Grocery Delivery (score 70+)", "Intent: Meal Kits (score 60+)", "NOT: FreshMart loyalty member"],
    refreshSchedule: "daily",
    channels:      ["display", "oo", "ctv"],
    createdAt:     "2026-03-01T10:00:00Z",
    updatedAt:     "2026-03-17T06:00:00Z",
    status:        "active",
  },
  {
    id:            "seg-012",
    name:          "Pro Contractor Segment",
    estimatedSize: 124_000,
    filters:       ["Intent: Professional Tools (score 80+)", "Intent: Construction (score 70+)", "Purchase history: Power Tools 3+ times"],
    refreshSchedule: "weekly",
    channels:      ["display", "oo"],
    createdAt:     "2026-02-22T10:00:00Z",
    updatedAt:     "2026-03-10T06:00:00Z",
    status:        "active",
  },
];

// ── Audience size estimator helper ───────────────────────────
export interface FilterDimension {
  id:       string;
  label:    string;
  type:     "intent" | "geo" | "demo" | "loyalty" | "behavioral" | "product";
  options:  { value: string; label: string; audienceImpact: number }[];
}

export const FILTER_DIMENSIONS: FilterDimension[] = [
  {
    id:    "intent_topic",
    label: "Intent Topic",
    type:  "intent",
    options: [
      { value: "power_tools",      label: "Power Tools",           audienceImpact: 840_000  },
      { value: "home_improvement", label: "Home Improvement",      audienceImpact: 2_400_000},
      { value: "consumer_elec",    label: "Consumer Electronics",  audienceImpact: 3_840_000},
      { value: "grocery",          label: "Grocery & Food",        audienceImpact: 8_200_000},
      { value: "athletic_wear",    label: "Athletic Wear",         audienceImpact: 1_280_000},
      { value: "health_wellness",  label: "Health & Wellness",     audienceImpact: 4_120_000},
      { value: "baby_products",    label: "Baby & Infant Products",audienceImpact: 1_240_000},
      { value: "smartphones",      label: "Smartphones",           audienceImpact: 5_600_000},
    ],
  },
  {
    id:    "geography",
    label: "Geography",
    type:  "geo",
    options: [
      { value: "national",  label: "National",        audienceImpact: 1.0   },
      { value: "midwest",   label: "Midwest",         audienceImpact: 0.22  },
      { value: "northeast", label: "Northeast",       audienceImpact: 0.19  },
      { value: "south",     label: "South",           audienceImpact: 0.38  },
      { value: "west",      label: "West",            audienceImpact: 0.21  },
    ],
  },
  {
    id:    "age_range",
    label: "Age Range",
    type:  "demo",
    options: [
      { value: "18_24", label: "18–24", audienceImpact: 0.14 },
      { value: "25_34", label: "25–34", audienceImpact: 0.21 },
      { value: "35_44", label: "35–44", audienceImpact: 0.20 },
      { value: "45_54", label: "45–54", audienceImpact: 0.18 },
      { value: "55_64", label: "55–64", audienceImpact: 0.14 },
      { value: "65_plus",label: "65+",  audienceImpact: 0.13 },
    ],
  },
  {
    id:    "hhi",
    label: "Household Income",
    type:  "demo",
    options: [
      { value: "under_50k",  label: "Under $50K",    audienceImpact: 0.28 },
      { value: "50_75k",     label: "$50K–$75K",     audienceImpact: 0.24 },
      { value: "75_100k",    label: "$75K–$100K",    audienceImpact: 0.20 },
      { value: "100_150k",   label: "$100K–$150K",   audienceImpact: 0.16 },
      { value: "over_150k",  label: "$150K+",        audienceImpact: 0.12 },
    ],
  },
];